var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('img',{staticClass:"img_card_component",attrs:{"src":_vm.imgUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }